import TargetType from '../enums/TargetType'

export type CommentFormValues = {
  targetId: string
  targetType: TargetType
  parentId?: string
  content: string
}

export const defaultCommentFormValues: CommentFormValues = {
  targetId: '',
  targetType: TargetType.CANDIDATE,
  content: '',
}